/**
 * This enum represents all the possible values for saved items, used in the Saved Item Dropdown and Open Item Modal.
 */
export var SavedItemType;
(function (SavedItemType) {
    SavedItemType["COMP_TABLE"] = "SAVED_COMP_TABLE_ITEM_TYPE";
    SavedItemType["STOCK_SCREEN"] = "SAVED_STOCK_SCREEN_ITEM_TYPE";
    SavedItemType["FUND_CHART"] = "SAVED_FUND_CHART_ITEM_TYPE";
    SavedItemType["FUND_SCREEN"] = "SAVED_FUND_SCREEN_ITEM_TYPE";
    SavedItemType["METRIC_SET"] = "METRIC_SET_ITEM_TYPE";
    SavedItemType["MODEL_PORTFOLIO"] = "MODEL_PORTFOLIO_ITEM_TYPE";
    SavedItemType["SCATTER_PLOT"] = "SAVED_SCATTER_PLOT_ITEM_TYPE";
    SavedItemType["SCORE"] = "SAVED_SCORE_ITEM_TYPE";
    SavedItemType["TECH_CHART"] = "SAVED_TECH_CHART_ITEM_TYPE";
    SavedItemType["TIMESERIES_TABLE"] = "SAVED_TIMESERIES_TABLE_ITEM_TYPE";
    SavedItemType["HYPOTHETICAL"] = "SAVED_HYPOTHETICAL_ITEM_TYPE";
    SavedItemType["ANALYSIS_PLAN"] = "SAVED_ANALYSIS_PLAN_ITEM_TYPE";
    SavedItemType["CUSTOM_PDF_REPORT"] = "SAVED_CUSTOM_PDF_REPORT_ITEM_TYPE";
    SavedItemType["PORTFOLIO_OPTIMIZER"] = "SAVED_PORTFOLIO_OPTIMIZER_ITEM_TYPE";
    SavedItemType["USER_TALKING_POINT"] = "USER_TALKING_POINT_ITEM_TYPE";
})(SavedItemType || (SavedItemType = {}));
